"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { useAuth } from "@/stores/use-auth";

export function useAuthRedirect(
  redirectTo: string,
  { fullPageLoad }: { fullPageLoad: boolean },
): boolean {
  const router = useRouter();
  const { isLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      if (fullPageLoad) {
        window.location.replace(redirectTo);
      } else {
        router.replace(redirectTo);
      }
    }
  }, [isLoading, isAuthenticated, router, redirectTo, fullPageLoad]);

  return isLoading || isAuthenticated;
}
